import { ITableModel } from '../../Interface/table-model.interface';
import { IShapeModel } from '../../Interface/shape-model.interface';
import { ECSType, getChangeSetType } from '../../../utils/changeset-type';

/**
 * 调整表格单元格的背景填充属性
 */
export default class AdjustTableCellBg {
    /**
     * 当表格有变更时，需要遍历子元素调整背景
     * 当且仅当表格大小调整/单元格大小调整/初始加载表格/插入或删除行列，需遍历所有单元格
     */
    public adjustTableBg(tableModel: ITableModel, changesetInfo?) {
        if (!this.didFrameChange(changesetInfo)) return;
        const offsetWidth = tableModel.props.style.width;
        const offsetHeight = tableModel.props.style.height;
        tableModel.props.items.flat().forEach((cellModel: IShapeModel) => {
            if (!this.isAjudstType(cellModel)) return;
            cellModel.props.style.offsetFrame = {
                offsetX: -cellModel.props.style.left,
                offsetY: -cellModel.props.style.top,
                offsetHeight,
                offsetWidth,
            };
        });
    }

    /**
     * 当表格填充方式有变更，或者单元格有变更时，调整单元格背景
     */
    public adjustCellBg(cellModel: IShapeModel, changesetInfo?) {
        if (!this.isAjudstType(cellModel) || this.didFrameChange(changesetInfo)) {
            cellModel.props.style.offsetFrame = undefined;
            return;
        }
        const tableModel = cellModel.parent as ITableModel;
        cellModel.props.style.offsetFrame = {
            offsetX: -cellModel.props.style.left,
            offsetY: -cellModel.props.style.top,
            offsetHeight: tableModel.props.style.height,
            offsetWidth: tableModel.props.style.width,
        };
    }

    /**
     * 是否为frame发生变更，或者初始加载表格
     */
    private didFrameChange(changesetInfo?): boolean {
        const csType = getChangeSetType(changesetInfo);
        return [ECSType.All, ECSType.Frame, ECSType.TableAddOrRemove].includes(csType);
    }

    /**
     * 仅图片-平铺/图案填充需要进行调整
     */
    private isAjudstType(cellModel: IShapeModel): boolean {
        const currentFill = cellModel.getBackgroundFill().getFillInfo();
        if (currentFill?.pattFill) return true;
        if (currentFill?.image?.tile) return true;
        return false;
    }
}
